import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "weight-picker-wrapper" }
const _hoisted_2 = {
  class: "selected-value pb-3",
  style: {"font-size":"24pt"}
}
const _hoisted_3 = { class: "weight-picker-container" }
const _hoisted_4 = { class: "d-grid px-2 pb-2 pb-md-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.selectedWeight.toFixed(1)) + " кг ", 1),
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "gradient gradient-left" }, null, -1)),
        _createElementVNode("div", {
          class: "weight-picker",
          ref: "pickerContainer",
          onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
        }, [
          _createElementVNode("div", {
            class: "weight-picker-content",
            style: _normalizeStyle({
            width: _ctx.contentWidth + 'px',
            paddingLeft: _ctx.viewportPadding + 'px',
            paddingRight: _ctx.viewportPadding + 'px',
          })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.range, (value, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                style: _normalizeStyle({
              color: _ctx.isInteger(value) ? '#000' : '#a8a8a8',
            }),
                class: "weight-item-wrapper"
              }, [
                _createElementVNode("div", {
                  class: "weight-item",
                  style: _normalizeStyle({
                width: '30px',
                textAlign: 'center',
                lineHeight: '25px',
                fontSize: _ctx.isInteger(value) ? 14 + 'pt' : 9 + 'pt',
              })
                }, _toDisplayString(parseFloat(value.toFixed(1) % 1) === 0
                  ? parseFloat(value.toFixed(0))
                  : parseFloat(
                      value.toFixed(1) - Math.trunc(value.toFixed(1))
                    ).toFixed(1) * 10), 5),
                _createElementVNode("div", {
                  class: "tick",
                  style: _normalizeStyle({
                height: _ctx.isInteger(value) ? 15 + 'px' : '7px',
                marginTop: _ctx.isInteger(value) ? 7 + 'px' : '15px',
                backgroundColor: '#ccc',
              })
                }, null, 4)
              ], 4))
            }), 128))
          ], 4)
        ], 544),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "gradient gradient-right" }, null, -1))
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "indicator" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Button, {
        label: "Сохранить",
        severity: "success",
        rounded: "",
        raised: "",
        onClick: _ctx.saveWeight
      }, null, 8, ["onClick"])
    ])
  ], 64))
}